import React, { useCallback, memo } from 'react';
import { priceState, numberFormat } from './util';
import { useSelector, useDispatch } from 'react-redux';
import { SET_CARD_OPEN_LOW_PRICE } from "../reducers/product";
var Price = function (_a) {
    var price = _a.price, f_sellout = _a.f_sellout, cnt_strock = _a.cnt_strock, seller = _a.seller, isMinishop = _a.isMinishop, hotdealPrice = _a.hotdealPrice, categoryId = _a.categoryId;
    var stdpcSelect = useSelector(function (state) { return state.product.stdpcSelect; });
    var priceInfo = useSelector(function (state) { return state.product.priceInfo; });
    var dispatch = useDispatch();
    var priceSet = useCallback(function () {
        var data = priceState({ price: price, f_sellout: f_sellout, cnt_strock: cnt_strock, seller: seller, isMinishop: isMinishop });
        var lowPriceData = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var arr = (args.filter(function (v) { return v && v; }));
            return arr.sort(function (a, b) { return a.price_b2c - b.price_b2c; })[0];
        };
        var categoryFirstValStr = categoryId ? categoryId.toString().substr(0, 1) : "0";
        var cardToOpenLowPrice = lowPriceData(priceInfo.low_card, priceInfo.low_open);
        dispatch({
            type: SET_CARD_OPEN_LOW_PRICE,
            payload: cardToOpenLowPrice && cardToOpenLowPrice.price_b2c ? cardToOpenLowPrice.price_b2c : 0
        });
        // 0: 단종 1: 일시품절 2: 가격비교예정 3: 산술가격
        switch (data) {
            case 0: {
                return React.createElement("span", { className: "no_price" }, isMinishop ? '-' : '단종된 상품');
            }
            case 1: {
                return React.createElement("span", { className: "no_price" }, "\uC77C\uC2DC\uD488\uC808");
            }
            case 2: {
                return React.createElement("span", { className: "no_price" }, "\uAC00\uACA9\uBE44\uAD50\uC608\uC815");
            }
            case 3: {
                var checkPrice = cardToOpenLowPrice && cardToOpenLowPrice.price_b2c && cardToOpenLowPrice.price_b2c > 0;
                return React.createElement(React.Fragment, null,
                    React.createElement("em", null, isMinishop ?
                        categoryFirstValStr === "2" ?
                            //미니샵이고 카테고리 첫번째 2면(조립pc) 계산식
                            numberFormat(stdpcSelect.each * stdpcSelect.price) :
                            numberFormat(hotdealPrice || price)
                        :
                            checkPrice && numberFormat(cardToOpenLowPrice.price_b2c)),
                    checkPrice && '원');
            }
            default: {
                return null;
            }
        }
    }, [stdpcSelect]);
    return priceSet();
};
export default memo(Price);



//////////////////
// WEBPACK FOOTER
// ./src/detail/utils/price.tsx
// module id = 219
// module chunks = 0